import { Select } from 'antd';
import styled from 'styled-components';

export const SelectList = styled(Select)``;
